
import * as React from 'react'
import { useState, useRef, useEffect} from 'react'
import { Button, Card, Form, Row, Col, Modal , Badge } from 'react-bootstrap'
import { BsSearch, BsFileEarmarkExcel, BsPencilSquare, BsTrash, BsChevronDown } from 'react-icons/bs' // Usamos íconos
import { CgAdd } from 'react-icons/cg'
import { useSelector } from 'react-redux'
import { RootState } from '../../../Store/store'
import * as XLSX from 'xlsx'
import DataTable from 'react-data-table-component'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import DTOEmpleado from './DTO/DTOEmpleado'
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados'
import DTOEmpleadoResponse from './DTO/DTOEmpleadoResponse'
import UsuariosServices from '../../../Services/Catalogos/Usuarios.Services'
import Supervisor from './DTO/Supervisor'
import InfoGeneralEmpleado from './InfoGeneralEmpleado'

export interface IRptRelacionBookPrectaProps {}

const mostrarDato = (valor?: string | number | null) =>
  valor === null || valor === undefined || String(valor).trim() === ''
    ? 'Sin capturar'
    : String(valor)

const formatearFechaEmpleado = (valor?: string | null) => {
  if (!valor) return 'Sin capturar'

  const partes = valor.slice(0, 10).split('-')
  return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor
}

function DetalleEmpleadoExpandido({ data }: { data: DTOEmpleado }) {
  const estadoReloj: { texto: string; color: string; colorTexto?: string } =
    data.modalidad === 'LABHOME'
      ? { texto: 'Reloj virtual', color: 'info', colorTexto: 'dark' }
      : data.modalidad === 'NOINOUT' || data.modalidad === 'ON'
        ? { texto: 'No aplica', color: 'secondary' }
        : data.activo
          ? data.fechaAltaRelojAccesos
            ? { texto: 'Confirmado', color: 'success' }
            : { texto: 'Pendiente', color: 'warning', colorTexto: 'dark' }
          : data.fechaBajaAccesosReloj
            ? { texto: 'Baja confirmada', color: 'danger' }
            : { texto: 'Pendiente de baja', color: 'dark' }

  const estadoSistemas: { texto: string; color: string; colorTexto?: string } = data.activo
    ? data.altaEnSistemas
      ? { texto: 'Completado', color: 'success' }
      : { texto: 'Pendiente', color: 'warning', colorTexto: 'dark' }
    : data.fechaBajaSistemas
      ? { texto: 'Baja completada', color: 'danger' }
      : { texto: 'Baja pendiente', color: 'dark' }

  return (
    <div className="bg-light border-top border-bottom px-4 py-3 w-100">
      <Row className="g-3">
        <Col xs={12} sm={6} lg={3}><strong>ID Reloj</strong><div>{mostrarDato(data.ac)}</div></Col>
        <Col xs={12} sm={6} lg={3}><strong>Horario</strong><div>{mostrarDato(data.horaEntrada)} - {mostrarDato(data.horaSalida)}</div></Col>
        <Col xs={12} sm={6} lg={3}><strong>Horario de comida</strong><div>{mostrarDato(data.horaSalidaComer)} - {mostrarDato(data.horaEntradaComer)}</div></Col>
        <Col xs={12} sm={6} lg={3}><strong>Fecha de ingreso</strong><div>{formatearFechaEmpleado(data.fechaIngreso)}</div></Col>
        <Col xs={12} sm={6} lg={3}><strong>Modalidad</strong><div>{mostrarDato(data.modalidad)}</div></Col>
        <Col xs={12} sm={6} lg={3}>
          <strong>Estado</strong>
          <div><Badge bg={data.activo ? 'success' : 'danger'}>{data.activo ? 'Activo' : 'Inactivo'}</Badge></div>
        </Col>
        <Col xs={12} sm={6} lg={3}><strong>Fecha de baja</strong><div>{formatearFechaEmpleado(data.fechaBajaEfectiva)}</div></Col>
        {/* <Col xs={12} sm={6} lg={3}><strong>Payroll</strong><div>{mostrarDato(data.payroll)}</div></Col> */}
        <Col xs={12} sm={6} lg={3}><strong>Correo asignado</strong><div>{mostrarDato(data.correoElectronicoEmpresa)}</div></Col>
        <Col xs={12} sm={6} lg={3}>
          <strong>Reloj</strong>
          <div><Badge bg={estadoReloj.color} text={estadoReloj.colorTexto}>{estadoReloj.texto}</Badge></div>
        </Col>
        <Col xs={12} sm={6} lg={3}>
          <strong>Alta/Baja IT</strong>
          <div><Badge bg={estadoSistemas.color} text={estadoSistemas.colorTexto}>{estadoSistemas.texto}</Badge></div>
        </Col>
        <Col xs={12} sm={6} lg={3}><strong>Supervisor</strong><div>{mostrarDato(data.nombreSupervisor)}</div></Col>
        {data.comentarios && (
          <Col xs={12}><strong>Comentarios</strong><div>{data.comentarios}</div></Col>
        )}
      </Row>
    </div>
  )
}

export default function CatRelacionBookPrecta(
  props: IRptRelacionBookPrectaProps
) {
  const mInvoices = useSelector(
    (state: RootState) => state.CatRelacionBookPrectaSlice
  )

  const [filtro, setFiltro] = useState('')
  const [Data, setData] = useState<Array<DTOEmpleado>>([])
  const [filteredData, setFilteredData] = useState<Array<DTOEmpleado>>([])
  const [show, setShowMsg] = useState(false)
  const [msg, setMsg] = useState('')
  const [header, setHeader] = useState('')
  const msgColor = 'primary'
  const gridRef = useRef<any>(null)

  const [showModal, setShowModal] = useState(false)

  const [idEmpNo, setIdEmpNo] = useState(0)
  const [ac, setAc] = useState(0)
  const [newName, setNewName] = useState('')
  const [newNumEmpleado , setNumEpleado] = useState('')
  const [newDepartamento , setNewDepartamento]  = useState('')
  const [newPuesto , setNewPuesto]  = useState('')
  const [newHoraEntrada, setNewHoraEntrada] = useState('')
  const [newHoraSalida, setNewHoraSalida] = useState('')
  const [activo, setActivo] = useState(false) // Nuevo estado para el campo Activo
  const [payroll, setPayroll] = useState('') // Estado para el campo Payroll
  const [oficina, setOficina] = useState('') // Estado para el campo Oficina
  const [horaEntradaComer, setHoraEntradaComer] = useState('') // Estado para HoraEntradaComer
  const [modalidad, setModalidad] = useState ('')
  const [horaSalidaComer, setHoraSalidaComer] = useState('') // Estado para HoraSalidaComer
  const [fechaIngreso , setFechaIngreso] = useState(currentDate())
  const [editando, setEditando] = useState(false)
  const [usaReloj, setUsaReloj] = useState(true);
  const [comentarios, setComentarios] = useState('')

  // --- ESTADOS OCULTOS PARA MANTENER DATOS DE IT ---
  const [altaEnSistemas, setAltaEnSistemas] = useState<boolean>(false)
  const [correoElectronicoEmpresa, setCorreoElectronicoEmpresa] = useState<string>('')
  const [fechaAltaRelojAccesos, setFechaAltaRelojAccesos] = useState<string>('')
  const [fechaBajaEfectiva, setFechaBajaEfectiva] = useState<string>('')

  // --- ESTADOS PARA EL MODAL DE BAJA INMEDIATA ---
  const [showModalBaja, setShowModalBaja] = useState(false)
  const [empleadoBaja, setEmpleadoBaja] = useState<any>(null)
  const [motivoBaja, setMotivoBaja] = useState('')
 const [estatusFiltro, setEstatusFiltro] = useState('todos') // Opciones: 'todos', 'activos', 'inactivos'

 
 const [fotoCorreo, setFotoCorreo] = useState<File | null>(null)
 const [activoOriginal, setActivoOriginal] = useState(false)

 const [supervisores, setSupervisores] = useState<Array<Supervisor>>([])
const [idSupervisorCatalogo, setIdSupervisorCatalogo] = useState<number | ''>('')
const [nombreSupervisor, setNombreSupervisor] = useState('')
const [correoSupervisor, setCorreoSupervisor] = useState('')
const [showModalInfoGeneral, setShowModalInfoGeneral] = useState(false)
const [numEmpleadoInfoGeneral, setNumEmpleadoInfoGeneral] = useState('')

const handleOpenInfoGeneral = (numEmpleado: string) => {
  setNumEmpleadoInfoGeneral(numEmpleado)
  setShowModalInfoGeneral(true)
}

const handleCloseInfoGeneral = () => {
  setShowModalInfoGeneral(false)
  setNumEmpleadoInfoGeneral('')
}


  
// useEffect(() => {
//     generarReporte();
// }, []);


const cargarSupervisores = () => {
  UsuariosServices.getAllSupervisor()
    .then((response) => {
      setSupervisores(response.data)
    })
    .catch((e: any) => {
      console.error('Error al cargar supervisores:', e)
    })
}

useEffect(() => {
  generarReporte()
  cargarSupervisores()
}, [])



  useEffect(() => {
    let resultado = Data;

    // 1. Filtramos por Estatus (Activo / Inactivo)
    if (estatusFiltro === 'activos') {
      resultado = resultado.filter((item) => item.activo);
    } else if (estatusFiltro === 'inactivos') {
      resultado = resultado.filter((item) => !item.activo);
    }

    // 2. Filtramos por Texto (Nombre o Número)
    if (filtro) {
      resultado = resultado.filter(
        (item) =>
          String(item.numEmpleado).toLowerCase().includes(filtro.toLowerCase()) ||
          item.name.toLowerCase().includes(filtro.toLowerCase())
      );
    }

    setFilteredData(resultado);
  }, [Data, filtro, estatusFiltro]); 
  


  const columnsRelacionBookPrecta = [
    // {
    //   name: 'ID Empleado',
    //   selector: (row: DTOEmpleado) => row.idEmpNo,
    //   sortable: true,
    //   width: '150px'
    // },
    {
      name: 'ID Reloj',
      selector: (row: DTOEmpleado) => row.ac,
      sortable: true,
      omit: true
    },
    
    {
      name: 'NumEmpleado', 
      selector: (row: DTOEmpleado)  => row.numEmpleado, 
      sortable : true, 
      width : '140px'
    },
    {
      name: 'Nombre',
      selector: (row: DTOEmpleado) => row.name,
      sortable: true,
      wrap: true,
      grow: 2
    },
    {
      name: 'Departamento', 
      selector: (row: DTOEmpleado) => row.departamento, 
      sortable : true, 
      wrap: true
    }, 
    {
      name: 'Puesto', 
      selector: (row: DTOEmpleado) => row.puesto, 
      sortable : true, 
      wrap: true
    }, 
//     {
//   name: 'Jefe Inmediato',
//   selector: (row: DTOEmpleado) => row.nombreSupervisor || 'No asignado',
//   sortable: true,
//   wrap: true,
//   width: '220px'
// },
// {
//   name: 'Correo ',
//   selector: (row: DTOEmpleado) => row.correoSupervisor || 'N/A',
//   sortable: true,
//   wrap: true,
//   width: '240px'
// },
    {
      name: 'Hora Entrada',
      selector: (row: DTOEmpleado) => row.horaEntrada,
      sortable: true,
      omit: true
    },
    {
      name: 'Hora Salida',
      selector: (row: DTOEmpleado) => row.horaSalida,
      sortable: true,
      omit: true
    },
    // {
    //   name: 'Payroll',
    //   selector: (row: DTOEmpleado) => row.payroll,
    //   sortable: true,
    //   width: '150px'
    // },
    {
      name: 'Oficina',
      selector: (row: DTOEmpleado) => row.oficina,
      sortable: true,
      wrap: true
    },
    {
      name: 'FechaIngreso',
      selector: (row: DTOEmpleado) => {
        if (!row.fechaIngreso) {
          return ''; // Devuelve una cadena vacía si no hay fecha
        }
        const fecha = new Date(row.fechaIngreso);
        return `${fecha.getDate().toString().padStart(2, '0')}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getFullYear()}`;
      },
      sortable: true,
      omit: true
    }, 

    {
      name: 'Modalidad',
      selector: (row: DTOEmpleado) => row.modalidad,
      sortable: true,
      omit: true
    },
    
    
    // {
    //   name: 'Hora Salida Comer',
    //   selector: (row: DTOEmpleado) => row.horaSalidaComer,
    //   sortable: true,
    //   width: '200px'
    // },
    // {
    //   name: 'Hora Entrada Comer',
    //   selector: (row: DTOEmpleado) => row.horaEntradaComer,
    //   sortable: true,
    //   width: '200px'
    // },
    {
      name: 'Activo',
      omit: true,
      cell: (row: DTOEmpleado) => (
        <input
          type="checkbox"
          checked={row.activo}
          disabled 
        />
      ),
    },
     { 
          name: 'Fecha Baja', 
          

          selector: (row: DTOEmpleado) => {
        if (!row.fechaBajaEfectiva) {
          return ''; 
        }
        const fecha = new Date(row.fechaBajaEfectiva);
        return `${fecha.getDate().toString().padStart(2, '0')}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getFullYear()}`;
      },
          
          omit: true
        },
        { name: 'Correo Asignado', selector: (row: DTOEmpleado) => row.correoElectronicoEmpresa || 'N/A', sortable: true, omit: true },
        //  {
        //       name: 'Reloj',
        //       width: '130px',
        //       cell: (row: DTOEmpleado) => {
        //         // Si es Home Office
        //         if (row.modalidad === 'LABHOME') {
        //           return <span className="badge bg-info text-dark">Reloj Virtual</span>;
        //         }
        //         // Si de plano no checa
        //         if (row.modalidad === 'NOINOUT' || row.modalidad === 'ON') {
        //           return <span className="badge bg-secondary">No Aplica</span>;
        //         }
        //         // Si es PRESENCIAL o cualquier otro normal
        //         return (
        //           <span className={`badge ${row.fechaAltaRelojAccesos ? 'bg-success' : 'bg-warning text-dark'}`}>
        //             {row.fechaAltaRelojAccesos ? 'Confirmado' : 'Pendiente'}
        //           </span>
        //         );
        //       },
        //     },

        // {
        //   name: 'Alta IT',
        //   width: '110px',
        //   cell: (row: DTOEmpleado) => (
        //     <Badge bg={row.altaEnSistemas ? 'success' : 'warning'} text={row.altaEnSistemas ? 'light' : 'dark'}>
        //       {row.altaEnSistemas ? 'Completado' : 'Pendiente'}
        //     </Badge>
        //   ),
        // },


{
  name: 'Reloj',
  omit: true,
  cell: (row: DTOEmpleado) => {
    if (row.modalidad === 'LABHOME') return <span className="badge bg-info text-dark">Reloj Virtual</span>;
    if (row.modalidad === 'NOINOUT' || row.modalidad === 'ON') return <span className="badge bg-secondary">No Aplica</span>;

    // SI ES BAJA
    if (!row.activo) {
      // Usamos la fecha de baja del reloj que llena IT
      const bajaConfirmada = row.fechaBajaAccesosReloj ? true : false; 
      return (
        <span className={`badge ${bajaConfirmada ? 'bg-danger' : 'bg-dark'}`}>
          {bajaConfirmada ? 'Baja Confirmada' : 'Pendiente Baja'}
        </span>
      );
    }

    // SI ES ALTA (Original)
    return (
      <span className={`badge ${row.fechaAltaRelojAccesos ? 'bg-success' : 'bg-warning text-dark'}`}>
        {row.fechaAltaRelojAccesos ? 'Confirmado' : 'Pendiente'}
      </span>
    );
  },
},
{
  name: 'Alta/Baja IT',
  omit: true,
  cell: (row: DTOEmpleado) => {

    // if (row.modalidad === 'NOINOUT' || row.modalidad === 'ON') return <span className="badge bg-secondary">No Aplica</span>;
    // SI ES BAJA
    if (!row.activo) {
      // Checamos si IT ya terminó su proceso de baja (puedes usar fechaBajaSistemas o el check)
      const cierreSistemas = row.fechaBajaSistemas ? true : false;
      return (
        <Badge bg={cierreSistemas ? 'danger' : 'dark'}>
          {cierreSistemas ? 'Baja Completada' : 'Baja Pendiente'}
        </Badge>
      );
    }
    // SI ES ALTA (Original)
    return (
      <Badge bg={row.altaEnSistemas ? 'success' : 'warning'} text={row.altaEnSistemas ? 'light' : 'dark'}>
        {row.altaEnSistemas ? 'Completado' : 'Pendiente'}
      </Badge>
    );
  },
},


        

    {
      name: 'Acciones',
      
      cell: (row: DTOEmpleado) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          <BsPencilSquare
            size={20}
            color="blue"
            onClick={() => handleOpenModal(row)}
            style={{ cursor: 'pointer' }}
          />
        
      <Button
                variant="outline-success"
                size="sm"
                title="Abrir Info General"
                aria-label="Abrir Info General"
                onClick={() => handleOpenInfoGeneral(row.numEmpleado)}
                style={{
                  width: '32px',
                  height: '28px',
                  padding: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <BsChevronDown size={18} />
              </Button>

          <BsTrash
            size={20}
            color="red"
            // ---> CAMBIA ESTA LÍNEA <---
            onClick={() => handleOpenModalBaja(row)} 
            style={{ cursor: 'pointer' }}
          />

        
 


        </div>
      ),
      width: '130px'
    }
  ]

  const generarReporte = () => {
    CatEmpleados.GetAllEmpleado()
      .then((response) => {
        setData(response.data)
        setFilteredData(response.data)
        setHeader('Informativo')
        setMsg('Se encontró la siguiente información...')
        setShowMsg(true)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg(`Ocurrió un error: ${e}`)
        setShowMsg(true)
      })
  }

 


  function currentDate ():  string {
    var today = new Date()
    // var dd = String(today.getDate()).padEnd(2,'0')
    var dd = String(today.getDate()).padStart(2,'0')
    var mm = String(today.getMonth() + 1  ).padStart(2, '0')
    var yyyy = today.getFullYear()
    return yyyy+'-' + mm + '-'  + dd
  }


  const downloadExcel = () => {
    // Filtrar las columnas relevantes para el reporte
    const filteredColumns = filteredData.map(({ numEmpleado,  name, departamento,  horaEntrada, horaSalida , oficina, fechaIngreso }) => ({
      
      
      numEmpleado,
      name,
      departamento, 
      horaEntrada,
      horaSalida,
      oficina, 
      fechaIngreso
    }));
  
    exportExcel(filteredColumns, 'ReporteEmpleados');
  };
  
  const exportExcel = (jsonData: any[], fileName: string) => {
    // Encabezados solo para las columnas seleccionadas
    const Heading = [[  'NumEmpleado',  'Nombre' , 'Departamento',   'HoraEntrada', 'HoraSalida' , 'Oficina']];
    
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, Heading); // Agregar encabezados
    XLSX.utils.sheet_add_json(ws, jsonData, { origin: 'A2', skipHeader: true }); // Agregar datos
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`); // Descargar archivo
  };
  
  const filtraReporte = (e: any) => {
    setFiltro(e.target.value)
    const filtered = Data.filter(
      (item) =>
        String(item.numEmpleado).toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(e.target.value.toLowerCase())
    )
    setFilteredData(filtered)
  }










function normalizarFechaInput(fecha?: string): string {
  if (!fecha) return ''

  // Si ya viene bien tipo 2026-03-25
  if (fecha.includes('-') && fecha.length >= 10) {
    return fecha.slice(0, 10)
  }

  // Si viene tipo 11/10/2016 00:00:00
  const soloFecha = fecha.split(' ')[0]
  const partes = soloFecha.split('/')

  if (partes.length === 3) {
    const mm = partes[0].padStart(2, '0')
    const dd = partes[1].padStart(2, '0')
    const yyyy = partes[2]
    return `${yyyy}-${mm}-${dd}`
  }

  return ''
}

function normalizarHoraInput(hora?: string): string {
  if (!hora) return ''

  const valor = hora.trim().toUpperCase()

  // 12 horas: 9:00:00 AM / 6:30:00 PM
  const match12 = valor.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/)
  if (match12) {
    let hh = parseInt(match12[1], 10)
    const mm = match12[2]
    const periodo = match12[3]

    if (periodo === 'AM' && hh === 12) hh = 0
    if (periodo === 'PM' && hh !== 12) hh += 12

    return `${String(hh).padStart(2, '0')}:${mm}`
  }

  // 24 horas: 09:00:00 / 18:00:00 / 09:00
  const match24 = valor.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)
  if (match24) {
    const hh = String(parseInt(match24[1], 10)).padStart(2, '0')
    const mm = match24[2]
    return `${hh}:${mm}`
  }

  return ''
}


function normalizarOficinaInput(oficina?: string): string {
  if (!oficina) return ''

  const valor = oficina.trim().toUpperCase()

  if (valor === 'NUEVO LAREDO') return 'Nuevo Laredo'
  if (valor === 'MONTERREY') return 'Monterrey'

  return oficina.trim()
}



  const handleOpenModal = (empleado?: DTOEmpleado) => {
    if (empleado) {
      setEditando(true)
      setIdEmpNo(empleado.idEmpNo)
      setAc(empleado.ac)
      setNewName(empleado.name)
      setNumEpleado(empleado.numEmpleado)
      setNewDepartamento(empleado.departamento)
      setNewPuesto(empleado.puesto)
      // setNewHoraEntrada(empleado.horaEntrada)
      // setNewHoraSalida(empleado.horaSalida)
      setNewHoraEntrada(empleado.horaEntrada || '')
      setNewHoraSalida(empleado.horaSalida || '')
      setFotoCorreo(null)
      setActivoOriginal(empleado.activo)
      
      setActivo(empleado.activo)
      setPayroll(empleado.payroll) 
      // setOficina(empleado.oficina) 
      setOficina(normalizarOficinaInput(empleado.oficina))
      setHoraEntradaComer(empleado.horaEntradaComer) 
      setHoraSalidaComer(empleado.horaSalidaComer) 
      // setFechaIngreso(empleado.fechaIngreso)
      setFechaIngreso(normalizarFechaInput(empleado.fechaIngreso))
      setModalidad(empleado.modalidad)
      setComentarios(empleado.comentarios || '')
      setAltaEnSistemas(empleado.altaEnSistemas || false)
      setCorreoElectronicoEmpresa(empleado.correoElectronicoEmpresa || '')
      setFechaAltaRelojAccesos(empleado.fechaAltaRelojAccesos || '')
      setFechaBajaEfectiva(empleado.fechaBajaEfectiva || '')
      setIdSupervisorCatalogo(empleado.idSupervisorCatalogo || '')
setNombreSupervisor(empleado.nombreSupervisor || '')
setCorreoSupervisor(empleado.correoSupervisor || '')

    } else {
      setEditando(false)
      setIdEmpNo(0)
      setAc(0)
      setNewName('')
      setNumEpleado('')
      setNewDepartamento('')
      setNewPuesto('')
      setNewHoraEntrada('')
      setNewHoraSalida('')
      setActivo(false)
      setPayroll('') 
      setOficina('') 
      setHoraEntradaComer('') 
      setHoraSalidaComer('') 
      setFechaIngreso('')
      setComentarios('')
      setAltaEnSistemas(false)
      setCorreoElectronicoEmpresa('')
      setFechaAltaRelojAccesos('')
      setFechaBajaEfectiva('')
      setActivoOriginal(false)
      setIdSupervisorCatalogo('')
setNombreSupervisor('')
setCorreoSupervisor('')
    }
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setIdEmpNo(0)
    setAc(0)
    setNewName('')
    setNewHoraEntrada('')
    setNewHoraSalida('')
    setActivo(false)
    setPayroll('')
    setOficina('')
    setHoraEntradaComer('')
    setHoraSalidaComer('')
    setFechaIngreso('')
    setShowModal(false)
    setFotoCorreo(null)
    setActivoOriginal(false)
    setIdSupervisorCatalogo('')
setNombreSupervisor('')
setCorreoSupervisor('')
  
  }

 

  



// const esReingreso = editando && !activoOriginal && activo

const esReingreso = editando && !activoOriginal && activo
const mostrarCamposAlta = !editando || esReingreso




const handleSave = () => {


  if (!oficina || oficina.trim() === "") {
    setHeader('Campo Requerido');
    setMsg('Por favor, seleccione una Oficina. Este campo es obligatorio para continuar.');
    setShowMsg(true);
    return; 
  } 
  const esReingreso = editando && !activoOriginal && activo
  const mostrarCamposAlta = !editando || esReingreso

  const empleadoData: DTOEmpleado = {
    idEmpNo: idEmpNo,
    ac: ac,
    name: newName,
    numEmpleado: newNumEmpleado,
    departamento: newDepartamento,
    puesto: newPuesto, 
    horaEntrada: newHoraEntrada,
    horaSalida: newHoraSalida,
    activo: activo,
    payroll: payroll,
    oficina: oficina,
    horaEntradaComer: horaEntradaComer,
    horaSalidaComer: horaSalidaComer,
    fechaIngreso: fechaIngreso,
    modalidad: modalidad,
    comentarios: comentarios,
    altaEnSistemas: altaEnSistemas,
    correoElectronicoEmpresa: correoElectronicoEmpresa,
    fechaAltaRelojAccesos: fechaAltaRelojAccesos ? fechaAltaRelojAccesos : undefined,
    fechaBajaEfectiva: fechaBajaEfectiva ? fechaBajaEfectiva : undefined,
    idSupervisorCatalogo: mostrarCamposAlta && idSupervisorCatalogo
      ? Number(idSupervisorCatalogo)
      : undefined,
  }

  const empleadoDataToSend = {
    ...empleadoData,
    activo: empleadoData.activo ? 1 : 0
  }

  if (editando && !esReingreso) {
    CatEmpleados.PostInsertUpdate(empleadoDataToSend)
      .then((response) => {
        const result = response.data as DTOEmpleadoResponse

        if (result.success) {
          setHeader('Actualizado')
          setMsg(result.message)
          setShowMsg(true)
          generarReporte()
          handleCloseModal()
        } else {
          setHeader('Error')
          setMsg(result.message)
          setShowMsg(true)
        }
      })
      .catch((e: any) => {
        setHeader('Error')
        setMsg(`Ocurrió un error al actualizar: ${e?.message || e}`)
        setShowMsg(true)
      })
  } else {
    CatEmpleados.AltaEmpleadoConFotoOpcional(empleadoDataToSend, fotoCorreo)
      .then((response) => {
        const result = response.data as DTOEmpleadoResponse

        if (result.success) {
          setHeader(esReingreso ? 'Reingreso procesado' : 'Insertado')
          setMsg(result.message)
          setShowMsg(true)
          generarReporte()
          handleCloseModal()
        } else {
          setHeader('Error')
          setMsg(result.message)
          setShowMsg(true)
        }
      })
      .catch((e: any) => {
        setHeader('Error')
        setMsg(`Ocurrió un error al ${esReingreso ? 'procesar el reingreso' : 'insertar'}: ${e?.message || e}`)
        setShowMsg(true)
      })
  }
}



  









const handleOpenModalBaja = (row: any) => {
    setEmpleadoBaja(row);
    setMotivoBaja('');
    setShowModalBaja(true);
  };

  const confirmarBaja = () => {
    if (!motivoBaja.trim()) {
      alert("Por favor ingresa un motivo de baja.");
      return;
    }

    const numEmpleado = empleadoBaja?.numEmpleado ?? empleadoBaja?.NumEmpleado;

    CatEmpleados.DeleteEmpleado(numEmpleado, motivoBaja)
      .then((response) => {
        const result = response.data;
        if (result.success) {
          setHeader('Eliminado');
          setMsg(result.message);
          setShowMsg(true);
          generarReporte();
          setShowModalBaja(false); // Cerramos el modal
        } else {
          setHeader('Error');
          setMsg(result.message);
          setShowMsg(true);
        }
      })
      .catch((e: any) => {
        setHeader('Error');
        setMsg(`Ocurrió un error: ${e?.message || e}`);
        setShowMsg(true);
      });
  };







  const horas = Array.from({ length: 18 }, (_, i) => i + 6); // Horas de 6 AM a 11 PM
  const minutos = Array.from({ length: 60 }, (_, i) => i); // Minutos de 00 a 59

  const formatHora = (hora: number, minuto: number, segundo: number = 0) => {
    const suffix = hora < 12 ? 'AM' : 'PM'
    hora = hora % 12 || 12 // Convierte de 24 horas a 12 horas
    return `${hora}:${minuto.toString().padStart(2, '0')}:${segundo.toString().padStart(2, '0')} ${suffix}`
  }

  return (
    

    <div className="mt-2">
  <Card style={{ width: '100%', height: '100%' }}> {/* Card principal expandido a todo el ancho y alto */}
    <Card.Body style={{ padding: '20px' }}>
      <div className="container-fluid"> {/* Usamos container-fluid para ocupar todo el ancho */}
        {/* Contenedor de búsqueda y botones */}
        <div
          className="row mb-4"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Card
            style={{
              paddingTop: '10px',
              paddingBottom: '5px',
              width: '100%',
              height: 'auto',
            }}
          >
            <Row className="align-items-center" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
              {/* Cuadro de búsqueda */}
              <Col xs="auto">
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Search..."
                  onChange={filtraReporte}
                  style={{
                    height: '35px',
                    width: '230px',
                    padding: '5px',
                  }}
                />
              </Col>




              <Col xs="auto">
                <Form.Select
                  size="sm"
                  value={estatusFiltro}
                  onChange={(e) => setEstatusFiltro(e.target.value)}
                  style={{ height: '35px', width: '150px', cursor: 'pointer', fontWeight: 'bold' }}
                  className={estatusFiltro === 'inactivos' ? 'text-danger' : estatusFiltro === 'activos' ? 'text-success' : ''}
                >
                  <option value="todos">Todos</option>
                  <option value="activos">Solo Activos</option>
                  <option value="inactivos">Solo Bajas</option>
                </Form.Select>
              </Col>


              {/* Botón de búsqueda */}
              <Col xs="auto">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={generarReporte}
                  style={{
                    height: '35px',
                    width: '80px',
                    padding: '5px',
                    position: 'relative',
                    zIndex: 1000,
                  }}
                >
                  <BsSearch /> Buscar
                </Button>
              </Col>

              {/* Botón de agregar */}
              <Col xs="auto">
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => handleOpenModal()}
                  style={{
                    height: '35px',
                    width: '70px',
                    padding: '5px',
                    backgroundColor: 'orange',
                  }}
                >
                  <CgAdd />
                </Button>
              </Col>

              {/* Botón de exportar a Excel */}
              <Col xs="auto">
                <Button
                  size="sm"
                  variant="success"
                  onClick={downloadExcel}
                  style={{
                    height: '35px',
                    width: '100px',
                    padding: '5px',
                  }}
                >
                  <BsFileEarmarkExcel />
                  &nbsp;Excel
                </Button>
              </Col>
            </Row>
          </Card>
        </div>

        {/* Tabla de datos */}
        <Row>
          <Col xs={12}>
            <Card style={{ width: '100%', height: '600px' }}> {/* Card con altura incrementada */}
              <Card.Body style={{ overflowY: 'auto', overflowX: 'hidden', height: '100%' }}>
                <DataTable
                  noHeader
                  defaultSortFieldId={'id'}
                  defaultSortAsc={true}
                  striped={true}
                  dense={true}
                  paginationPerPage={10}
                  pagination
                  highlightOnHover
                  columns={columnsRelacionBookPrecta}
                  data={filteredData}
                  expandableRows
                  expandableRowsComponent={DetalleEmpleadoExpandido}
                  pointerOnHover
                  responsive={true}
                  customStyles={{
                    table: {
                      style: {
                        width: '100%', // Ocupa todo el ancho del contenedor
                        height: '100%', // Ocupa todo el alto del contenedor
                      },
                    },
                    headCells: {
                      style: {
                        fontWeight: 'bold',
                        backgroundColor: '#f8f9fa',
                        padding: '10px',
                        fontSize: '16px',
                      },
                    },
                    rows: {
                      style: {
                        minHeight: '45px', // Aumenta la altura de cada fila para mayor visibilidad
                        fontSize: '15px', // Aumenta el tamaño de la fuente
                      },
                    },
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Card.Body>
  </Card>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editando ? 'Editar Empleado' : 'Nuevo Empleado'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
           
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
            </Form.Group>

            
            <Form.Group> 
  <Form.Label>NumEmpleado</Form.Label>
  <Form.Control   
    type="text" 
    value={newNumEmpleado} 
    onChange={(e) => {
      const valor = e.target.value;
      setNumEpleado(valor);

      // Solo actualizamos el AC si el empleado está marcado como "Usa Reloj"
      if (usaReloj) {
        const sinCeros = valor.replace(/^0+/, '');
        setAc(sinCeros === '' ? 0 : Number(sinCeros));
      } else {
        setAc(0);
      }
    }} 
  />
</Form.Group>


            

<Form.Group className="mb-2">
  <Form.Check 
    type="switch"
    label="¿Registra en Reloj Checador?"
    checked={usaReloj}
    onChange={(e) => {
      const checa = e.target.checked;
      setUsaReloj(checa);
      if (!checa) {
        setAc(0); // Si no usa reloj, forzamos AC a 0
      } else {
        // Si vuelve a marcar que sí, recalculamos el AC desde el NumEmpleado
        const sinCeros = newNumEmpleado.replace(/^0+/, '');
        setAc(sinCeros === '' ? 0 : Number(sinCeros));
      }
    }}
  />
</Form.Group>

             <Form.Group>
  <Form.Label>ID Reloj (AC)</Form.Label>
  <Form.Control
    type="number"
    value={ac}
    onChange={(e) => setAc(Number(e.target.value))}
    disabled={!usaReloj} // Se deshabilita si no usa reloj
    style={!usaReloj ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
  />
</Form.Group>
            <Form.Group>
              <Form.Label>Departamento</Form.Label>
              <Form.Control type="text" value={newDepartamento} onChange={(e) => setNewDepartamento(e.target.value)} />
            </Form.Group>

            <Form.Group>
              <Form.Label>Puesto</Form.Label>
              <Form.Control type="text" value={newPuesto} onChange={(e) => setNewPuesto(e.target.value)} />
            </Form.Group>

            <Row>
              <Col md={6}>
               

                <Form.Group>
  <Form.Label>Hora Entrada</Form.Label>
  <Form.Control
    type="time"
    // value={newHoraEntrada.slice(0, 5)}
    value={normalizarHoraInput(newHoraEntrada)}
    onChange={(e) => setNewHoraEntrada(e.target.value ? e.target.value + ':00' : '')}
  />
</Form.Group>


              </Col>
              <Col md={6}>
                

                <Form.Group>
  <Form.Label>Hora Salida</Form.Label>
  <Form.Control
    type="time"
    // value={newHoraSalida.slice(0, 5)}
     value={normalizarHoraInput(newHoraSalida)}
    onChange={(e) => setNewHoraSalida(e.target.value ? e.target.value + ':00' : '')}
  />
</Form.Group>
              </Col>
            </Row>

{/* <Form.Group className="mt-2">
  <Form.Label>Reportara a</Form.Label>
  <Form.Select
    value={idSupervisorCatalogo}
    onChange={(e) => {
      const value = e.target.value
      const id = value ? Number(value) : ''
      setIdSupervisorCatalogo(id)

      const sup = supervisores.find((x) => x.idSupervisor === Number(value))
      setNombreSupervisor(sup?.nombre || '')
      setCorreoSupervisor(sup?.correo || '')
    }}
  >
    <option value="">Seleccione</option>
    {supervisores.map((sup) => (
      <option key={sup.idSupervisor} value={sup.idSupervisor}>
        {sup.nombre}
      </option>
    ))}
  </Form.Select>
</Form.Group>

<Form.Group className="mt-2">
  <Form.Label>Correo del Jefe Inmediato</Form.Label>
  <Form.Control
    type="text"
    value={correoSupervisor || ''}
    disabled
  />
</Form.Group> */}


{mostrarCamposAlta && (
  <>
    <Form.Group className="mt-2">
      <Form.Label>Reportará a</Form.Label>
      <Form.Select
        value={idSupervisorCatalogo}
        onChange={(e) => {
          const value = e.target.value
          const id = value ? Number(value) : ''
          setIdSupervisorCatalogo(id)

          const sup = supervisores.find((x) => x.idSupervisor === Number(value))
          setNombreSupervisor(sup?.nombre || '')
          setCorreoSupervisor(sup?.correo || '')
        }}
      >
        <option value="">Seleccione</option>
        {supervisores.map((sup) => (
          <option key={sup.idSupervisor} value={sup.idSupervisor}>
            {sup.nombre}
          </option>
        ))}
      </Form.Select>
    </Form.Group>

    <Form.Group className="mt-2">
      <Form.Label>Correo del Jefe Inmediato</Form.Label>
      <Form.Control
        type="text"
        value={correoSupervisor || ''}
        disabled
      />
    </Form.Group>
  </>
)}


            

            {/* <Form.Group>
              <Form.Label>Oficina</Form.Label>
              <Form.Control type="text" value={oficina} onChange={(e) => setOficina(e.target.value)} />
            </Form.Group> */}

            <Form.Group>
  <Form.Label>Oficina</Form.Label>
  <Form.Select
    value={oficina}
    onChange={(e) => setOficina(e.target.value)}
  >
    <option value="">Seleccione una oficina</option>
    <option value="Nuevo Laredo">Nuevo Laredo</option>
    <option value="Monterrey">Monterrey</option>
    <option value="Laredo Tx.">Laredo Tx.</option>
    <option value="CDMX">CDMX</option>
     <option value="Oficina General">Oficina General</option>
     <option value="Colombia">Colombia</option>
  </Form.Select>
</Form.Group>

            {/* <Form.Group>
              <Form.Label>Modalidad</Form.Label>
              <Form.Control type="text" value={modalidad} onChange={(e) => setModalidad(e.target.value)} />
            </Form.Group> */}

            

                      <Form.Group>
  <Form.Label>Modalidad</Form.Label>
  <Form.Select
    value={modalidad}
    onChange={(e) => setModalidad(e.target.value)}
  >
    <option value="">Seleccione una Modalidad</option>
    <option value="ON">ON</option>
    <option value="PRESENCIAL">PRESENCIAL</option>
    <option value="NOINOUT">NOINOUT</option>
    <option value="LABHOME">LABHOME</option>
    <option value="LABHOMECHECK">LABHOMECHECK</option>

    
  </Form.Select>
</Form.Group>


            <Form.Group className="mb-3 mt-3">
              <Form.Label>Comentarios / Motivo de Alta</Form.Label>
              <Form.Control 
                as="textarea" 
                rows={2} 
                placeholder="Escribe algún comentario si es necesario..."
                value={comentarios} 
                onChange={(e) => setComentarios(e.target.value)} 
              />
            </Form.Group>

           
{/* {!editando && ( */}
{/* {(!editando || esReingreso) && ( */}

{mostrarCamposAlta && (
  <Form.Group className="mb-3 mt-2">
    <Form.Label>Foto opcional del empleado</Form.Label>
    <Form.Control
      type="file"
      accept=".jpg,.jpeg,.png,image/jpeg,image/png"
      onChange={(e) => {
        const file = (e.target as HTMLInputElement).files?.[0] || null
        setFotoCorreo(file)
      }}
    />
    <Form.Text className="text-muted">
      La imagen se guardará en el expediente del empleado y también se adjuntará al correo de alta.
    </Form.Text>
  </Form.Group>
)}




            <Form.Group> 
            <Form.Label>FechaIngreso</Form.Label>
              <Form.Control
  value={fechaIngreso}
  type="date"
  name="Inicio"
  placeholder="Inicio"
  title="Inicio"
  alt="Inicio"
  data-date-format="YYYY-mm-dd"
  onChange={(e) => setFechaIngreso(e.target.value)}
  size="sm"
/>

            </Form.Group>

            

            <Row>
              
            
            </Row>

            <Form.Group>
              <Form.Check
                type="checkbox"
                label="Activo"
                checked={activo}
                onChange={(e) => setActivo(e.target.checked)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editando ? 'Actualizar' : 'Guardar'}
          </Button>
        </Modal.Footer>
      </Modal>


      {/* --- MODAL PARA PROCESAR BAJAS INMEDIATAS --- */}
      <Modal show={showModalBaja} onHide={() => setShowModalBaja(false)} centered backdrop="static">
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title className="h6 mb-0">Procesar Baja de Empleado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <p className="mb-3">
              Estás a punto de procesar la baja de <b>{empleadoBaja?.name}</b>. <br/>
              Esta acción desactivará su acceso al checador.
            </p>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Motivo / Comentarios de la Baja</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Escribe el motivo de la baja..."
                value={motivoBaja}
                onChange={(e) => setMotivoBaja(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalBaja(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmarBaja}>
            Confirmar Baja 
          </Button>
        </Modal.Footer>
      </Modal>

      <InfoGeneralEmpleado
        show={showModalInfoGeneral}
        numEmpleado={numEmpleadoInfoGeneral}
        onClose={handleCloseInfoGeneral}
      />

      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => {
          setShowMsg(false)
        }}
      />
    </div>
  )
}
